export function loadMaps(initializerCallback: () => void): void {
    try {
        window.addEventListener;
    } catch (e) {
        throw new Error('loadMap must be run in browser')
    }

    if (window.google && window.google.maps) {
        initializerCallback()
        return
    }

    window.initMap = initializerCallback

    const script_tag = document.createElement('script')
    script_tag.setAttribute("type", "text/javascript")
    script_tag.setAttribute("src", `https://maps.googleapis.com/maps/api/js?key=AIzaSyBoJUSZnYnSGEgfpjxHXHzbLHqKd7KJ4Yc&callback=initMap`)
    script_tag.setAttribute("async", "true");
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag)
}

export function setInfoWindowStyles(): HTMLStyleElement {
    const style = document.createElement('style')
    style.innerHTML = `
    .gm-style .gm-style-iw-c {
      max-height: none !important;
      border: 1px solid #c6cade !important;
      border-radius: 4px !important;
      padding: 0 !important;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .08) !important;
    }

    .gm-style .gm-style-iw-d {
      overflow: auto !important;
      max-height: none !important;
    }

    .gm-style-iw-t::before {
      border-top: 10px solid #c6cade !important;
    }

    .gm-style .gm-style-iw-t::after {
      top: -1px !important;
      border-left: 10px solid transparent !important;
      border-right: 10px solid transparent !important;
      border-top: 10px solid #fff !important;
    }

    .gm-ui-hover-effect {
      top: 9px !important;
      right: 7px !important;
      width: 32px !important;
      height: 32px !important;
      opacity: 1 !important;
    }

    .gm-ui-hover-effect:hover img {
      filter: invert(64%) sepia(99%) saturate(451%) hue-rotate(167deg) brightness(101%) contrast(95%);
    }

    .gm-ui-hover-effect img {
      width: 32px !important;
      height: 32px !important;
      margin: 0 !important;
      filter: invert(48%) sepia(44%) saturate(4004%) hue-rotate(166deg) brightness(98%) contrast(101%);
    }
    .marker-clusterer-marker > div {
      color: #F8F8F8!important;
    }
    `
    document.head.appendChild(style)
    return style
}
